import { useEffect } from 'react';

import { startReportingWindowSize, startReportingCopy, startReportingPaste } from '@framework/app';

import useSendStatelessInsight from './useSendStatelessInsight';

const useRegisterEventReporting = (): void => {
    const sendStatelessInsight = useSendStatelessInsight();
    useEffect(() => {
        const stopReportingWindowSize = startReportingWindowSize(sendStatelessInsight);
        const stopReportingCopy = startReportingCopy(window, sendStatelessInsight);
        const stopReportingPaste = startReportingPaste(window, sendStatelessInsight);

        return () => {
            stopReportingWindowSize();
            stopReportingCopy();
            stopReportingPaste();
        };
    }, []);
};

export default useRegisterEventReporting;
